Apt.fn.make('videos', {
	/**
	 * Initialize module
	 */
	init: function() {
		this.filters = Apt.fn.filters().init('videos', {
			source: 'api/v1/videos',
			view: 'videos.results',
			filters: $.get('filters')
		});
	},

	/**
	 * Check for available videos
	 */
	transform: function() {
		$$('video').each(function(el) {
			var $el = $(el);

			$el.replaceWith(
				'<iframe src="https://player.vimeo.com/video/' + $el.data('id') + '" ' +
				'class="' + $el.attr('class') + '" title="Video" loading="lazy"></iframe>'
			)
		});
	},

	/**
	 * Unload module
	 */
	unload: function() {
		this.filters.$destroy();
	}
});